import { WorldTrafficResponseItem } from "../Api/WorldTrafficApi";
import { ValueChartDataProvider, ValueChartItem } from "../Components/PercentValueChart/ValueChart";
import { countryCodeToCountry } from "../Helpers/CountryCodeToCountry";
import { ValidWorldMapTypes } from "../Views/WorldTrafficChart/WorldTraffic";

/**
 * Represents the data that we receive from the server. This data will be 
 * shown on a graph on the analytics page
*/
export default class WorldTrafficStats implements ValueChartDataProvider {
    public readonly data: ValueChartItem[];
    public readonly map: ValidWorldMapTypes;
    public readonly total: number;

    constructor(
        data: WorldTrafficResponseItem[] = [],
        total: number = 0,
        map: ValidWorldMapTypes = "world",
    ) {
        this.map = map;
        this.total = total;

        /**
        * The data shape used by the chart is different than the data that is sent to 
        * us from the server so we need to convert it.
        */
        this.data = data
            .sort((a, b) => a.value - b.value)
            .map((item): ValueChartItem => ({
                name: item.name,
                value: item.value,
                children: [],
            }));

    }

    public getRawData(): ValueChartItem[] {
        return this.data;
    }

    public getChartTotal(): number {
        return this.total;
    }

    public getChartLabels(): string[] {
        return Object.values(this.getChartData()).map((item) => countryCodeToCountry(item.name));
    }

    public getChartData(): ValueChartItem[] {
        if (this.data.length > 10) {
            const topX = this.data.slice(
                this.data.length - 9,
                this.data.length,
            );

            const other = {
                name: "Other",
                value: this.total - topX.reduce((carry, item) => carry += item.value, 0),
                children: [],
            };

            return [other, ...topX];
        } else {
            return this.data;
        }
    }
}
